import React from "react";
import { Quote } from "lucide-react";
import { originStory } from "../data/mock";

export default function OriginStory() {
  const { quote } = originStory;

  return (
    <section id="story" className="relative py-28 px-4 sm:px-6 lg:px-10 bg-brown-gradient grain text-[#FFF8E7]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FFE357] text-[#0F0F10] text-xs font-semibold uppercase tracking-widest mb-4">
            Origin story
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">
            <span className="squiggle">Building products</span>
            <br />from 5 years now!
          </h2>

          <div className="mt-10 relative">
            <Quote className="absolute -top-3 -left-3 w-10 h-10 text-[#FFE357]/40" />
            <p className="font-serif-italic text-2xl sm:text-3xl leading-snug text-[#FFE357] pl-6">
              “{quote}”
            </p>
          </div>

          <div className="mt-10 flex items-center gap-2 text-white/60 font-mono text-sm">
            <span>2020</span>
            <span className="flex-1 h-px bg-white/20"></span>
            <span>2025</span>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-3 rounded-[28px] bg-[#FFE357]/20 -z-10 rotate-1"></div>
          <div className="rounded-3xl bg-[#FFF8E7] border-[1.5px] border-[#0F0F10] shadow-[8px_8px_0_#000] overflow-hidden">
            <iframe
              src="https://www.linkedin.com/embed/feed/update/urn:li:share:6661241055771529216?collapsed=1"
              title="LinkedIn post — findhope peer counseling launch"
              className="w-full block"
              style={{ height: "703px", maxHeight: "75vh", border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>

          <a
            href="https://www.linkedin.com/posts/tharunsaierukulla_findhope-activity-6661241056757190656-BZCn?utm_source=share&utm_medium=member_desktop&rcm=ACoAACbX52cB1kFx3DOYz8BjLGgQITh8b9fI6ZQ"
            target="_blank"
            rel="noopener noreferrer"
            className="origin-badge absolute -top-6 right-6 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#FFE357] text-[#0F0F10] text-sm font-semibold border-[1.5px] border-[#0F0F10] shadow-[3px_3px_0_#000] hover:shadow-[5px_5px_0_#000] hover:-translate-y-0.5 transition-all"
          >
            <span>it all started here</span>
            <span aria-hidden="true" className="origin-arrow inline-block">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
